
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { getCondoSearchBodyDetails, getHeaders } from '@share/utils';
import { ILuxuryHome, ISessionKey } from '@share/common-types';
import { getSelectedCurrency } from '@share/utils';
import { axiosInstance } from '@share/utils';
import { AppThunk } from '@share/utils';
import { Urls } from '@share/constants';

export interface ILuxuryHomeAvailability {
  home: ILuxuryHome;
  sessionKey: ISessionKey;
}

export interface ILuxuryHomeAvailabilityLoading {
  id: number;
  loading: boolean;
}

export interface ILuxuryHomesSearchState {
  homes: ILuxuryHomeAvailability[];
  loading: ILuxuryHomeAvailabilityLoading[];
}

export const luxuryHomesSearchInitialState: ILuxuryHomesSearchState = {
  homes: [],
  loading: [],
};

const luxuryHomesSearchSlice = createSlice({
  name: 'luxury-homes-search',
  initialState: luxuryHomesSearchInitialState,
  reducers: {
    setHomesAvailability: (state: ILuxuryHomesSearchState, { payload }: PayloadAction<ILuxuryHomeAvailability | undefined>) => {
      if (payload) {
        state.homes = [ ...state.homes, payload ];
      } else {
        state.homes = [ ...state.homes ];
      }
    },
    setLoading: (state: ILuxuryHomesSearchState, { payload }: PayloadAction<ILuxuryHomeAvailabilityLoading>) => {
      const index = state.loading.findIndex((l: ILuxuryHomeAvailabilityLoading) => l.id === payload.id);
      if (index !== -1) {
        state.loading[index] = payload;
      } else {
        state.loading = [...state.loading, payload];
      }
    },
    setDefaultValues: () => {
      return luxuryHomesSearchInitialState;
    },
  },
});

export const luxuryHomesSearchActions = luxuryHomesSearchSlice.actions;

export const luxuryHomesSearchReducer = luxuryHomesSearchSlice.reducer;

export const getLuxuryHomeAvailability = (
  condoId: number,
  condoRequest?: any,
): AppThunk => {
  return async (dispatch, getState) => {
    dispatch(luxuryHomesSearchActions.setLoading({ id: condoId, loading: true }));
    
    const { loginStore } = getState();
    const { account } = loginStore;

    const currency = getSelectedCurrency(account);

    try {  
      const res = await axiosInstance.post(
        Urls.CondoDetails,
        { 
          condoId,
          searchType: condoRequest?.requestType,
          ...getCondoSearchBodyDetails(condoRequest),
          currency,
        },
        { ...getHeaders() },
      );

      dispatch(luxuryHomesSearchActions.setLoading({ id: condoId, loading: false }));

      const newHome = { home: res.data?.condoDetails, sessionKey: res.data.sessionKey };
      dispatch(luxuryHomesSearchActions.setHomesAvailability(newHome));

    } catch (error: any) {
      dispatch(luxuryHomesSearchActions.setLoading({ id: condoId, loading: false }));

      dispatch(luxuryHomesSearchActions.setHomesAvailability(undefined));
    }
  };
};
